import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { CommonFunction } from '../shred/common-function';
import { CartService } from '../services/cart/cart.service';
import { Location } from '@angular/common';
import { VenuelistService } from '../services/venuelist/venuelist.service';
import { CartPanelService } from '../services/cartpanel/cart-panel.service';


declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  searchZipCode: any;
  venueId: any;
  is_login = false;
  login_user_id: any;
  cart_list: any;
  discount_off: any;
  order_total: any;
  deliveryCharge: any;
  grand_total: any;
  cart_data = false;
  cart_products_length: any;
  menu_type = null;
  totalVenue: any;
  venueList: any;
  searchZipCodeDisplay: any;
  currentCity: any;
  displayVenuesText: any;
  venueName: any;
  displayText: any;
  currentUrl: any;
  showHideSearchInputText = false;
  showHideSearchText = true;
  searchForm: FormGroup;
  navHideShow = false;
  navHideShowMobile = false;
  priceArray: any = [];
  max_price_apply: any;
  searchVenueName: any;
  showHideRadTextDataLocation = true;
  showHideRadTextDataVenue = false;
  minShisha = 0;
  leftShisha = 0;
  shishaMessageDispaly: any;
  hideCartMenuForMobile = false;
  logoHeader = true ; // hidden by default
  searchHeader = false;
  currentUrlFinder:any;
  headerLeft = true;
  headerRight = true;
  searchAreaNameDisplay: any;
  venueDetail: any;
  showCart: boolean = true;
  isGroupBooking: boolean = false;
  is_guest = false;
  isMainGuestCartAdded = false;
  showExtraGuestPopup = true;
  is_party: boolean = false;
  showCartPanel: boolean = false;
  delivery_cost: any;
  ticket_type=null;
  enableMenuGoBack:boolean=false;

  constructor(
    private CartService: CartService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private VenuelistService: VenuelistService,
    private formBuilder: FormBuilder,
    public cartPanel:CartPanelService

  ) { 

    $('#vip_menu_confirm_modal').modal('toggle');
  }

  ngOnInit() {

    var completeUrl=this.location.prepareExternalUrl(this.location.path());

    if(completeUrl.includes('menu/') && localStorage.getItem('ticket_type')!==null && localStorage.getItem('ticket_type')==='vip'){
      this.enableMenuGoBack=true;
      
    }else{
      this.enableMenuGoBack=false;
    }

    this.ticket_type=localStorage.getItem('ticket_type');

    this.searchForm = this.formBuilder.group({
      venuename: ['', Validators.required],
    });
    this.isGroupBooking = (localStorage.getItem('group_booking') == '1') && (localStorage.getItem('group_booking') == '1') ? true : false;
    this.is_login = CommonFunction.checkLogin();
    this.displayVenuesText = false;
    this.displayText = false;
    var that = this;
    this.cart_products_length = 0;
    if (this.is_login) {
      this.login_user_id = localStorage.getItem('user_id');
      this.getUserCartData();
    } else {
      this.login_user_id = '';
    }

    if(localStorage.getItem('is_party') && localStorage.getItem('is_party') == '1'){
      this.is_party = true
    }

    if((localStorage.getItem('booking_available') == '1') && (localStorage.getItem('group_booking') == '1')){
      this.showCart = true;
      this.headerRight = true;
    }else if((localStorage.getItem('booking_available') == '0') && (localStorage.getItem('group_booking') == '1')){
        this.showCart = true;
        this.headerRight = true;
    }else{
        this.showCart = false;
        this.headerRight = false;
    }

    if(localStorage.getItem('is_guest') && localStorage.getItem('is_guest') == '1'){
      this.is_guest = true;
     }    

    if (!!localStorage.getItem('searchZipCode')) {
      this.searchZipCode = localStorage.getItem('searchZipCode');
      this.searchZipCodeDisplay = CommonFunction.removeUnderScoreAddSpace(this.searchZipCode);
      this.getVenueByZipcode();
    }

    if (!!localStorage.getItem('search_venue_name')) {
      this.searchZipCode = localStorage.getItem('search_venue_name');
      this.getVenueByZipcode();
      this.getVenueName();
    }

    if (!!localStorage.getItem('searchAreaName')) {
      this.searchAreaNameDisplay = localStorage.getItem('searchAreaName');
      this.searchZipCodeDisplay = CommonFunction.removeUnderScoreAddSpace(this.searchAreaNameDisplay);
    }



    if (!!localStorage.getItem('searchZipCode') && !!localStorage.getItem('restaurant_name')) {
      this.getVenueName()
    }

    // if(!!this.route.snapshot.paramMap.get('searchZipCode')){
    //   this.searchZipCode = this.route.snapshot.paramMap.get('searchZipCode');
    // }else{
    //   this.searchZipCode = 'All';
    // }

    if (!!this.route.snapshot.paramMap.get('venueId')) {
      this.venueId = this.route.snapshot.paramMap.get('venueId');
    } else {
      this.venueId = 1;
    }

    if (localStorage.getItem('venue_id')) {
      this.venueId = localStorage.getItem('venue_id');
    }

    $(document).on('click', '#cart_button, #cart_button_mobile', ()=>{
      this.showCartSection();
      this.getUserCartData();
    });

    $(document).on('click', '#close-cart', ()=>{
      this.hideCartSection();
    });


    $(document).ready(function () {
      // $('#cart_button').click(function () {
      //   $('#panel-cart').addClass('show');
      //   that.getUserCartData();
      // });

      // $('#cart_button_mobile').click(function () {
      //   $('#panel-cart').addClass('show');
      //   that.getUserCartData();
      // });
      // $('#close-cart').click(function () {
      //   $('#panel-cart').removeClass('show');
      // });
      $('#header_check').click(function () {
        that.getUserCartData();
      });

      $('#searchCountList').click(function () {
        that.getVenueByZipcode();
      });

      $('#searchVenueText').click(()=> {
        that.getVenueName();
      });

      $('#searchInputSearchArea').click(()=> {
        that.getCurrentUrl();
      });

      $('#showHidenavigationBar').click(()=> {
        that.showHideNavigation();
        that.showMobileHideNavigation();
      });

      $('#showHideRadTextId').click(()=> {
        that.showHideRadText();
      });

      that.getVenueByVenuId(that.venueId);

      $(document).click(function (e) {
        var container = $('#removeCartDataExtrabtn, #removeCartDataItembtn, #panel-cart, #cart_button, #cart_button_mobile, #checkout-error-button-ok');
        var hasShowClass = container.hasClass('show')
        var className = e.target.className;
        var targetId = e.target.id

        if (container.has(e.target).length === 0 && hasShowClass &&
          className !== 'cart-value' && className !== 'ti ti-close' &&
          targetId !== 'content' && targetId !== 'cart_button') {
          $('#close-cart').click();
        }
      });

      setTimeout(function () {
        $('.add').click(function () {
          $(this).prev().val(+$(this).prev().val() + 1);
        });
        $('.sub').click(function () {
          if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
        });
      }, 2000);
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd ) {
        this.currentUrlFinder = event.url;  // event.url has current url
        this.checkHeaderParts(this.currentUrlFinder);
      }
    });

  }

  showHideRadText() {
    var newcurrentUrl = this.router.url;
    var regExpVenuelist = '/venuelist/' + '.*$';
    var regExpAddpeople = '/addpeople/' + '.*$';
    var regExpmenu = '/menu/' + '.*$';

    if (newcurrentUrl.match(regExpmenu)) {
      this.showHideRadTextDataLocation = false;
      this.showHideRadTextDataVenue = true;
    } else {
      this.showHideRadTextDataLocation = true;
      this.showHideRadTextDataVenue = false;
    }
}

showSearchHeader(){
  this.logoHeader = false;
  this.searchHeader = true;
}

closeSearchHeader(){
  this.logoHeader = true;
  this.searchHeader = false;
}

  searchFormSubmit() {

    if (this.searchForm.valid && !!this.searchForm.value.venuename) {
      var searchtext = this.searchForm.value.venuename;

      var searchData = {
          venuename:searchtext,
        }

      this.CartService.searchBarData(searchData).subscribe(resultArray => {
        var result = resultArray;
        if (result.status === 'success') {
          //searchZipCode = searchZipCode.replace(/\s/g, '_'); // remove space relace with '_'
          setTimeout(() => {
            window.location.replace(result.url);
          }, 100);
        } else {

        }
      })

    } else {
      // console.log('error');
      // this.validateAllFields(this.searchForm);
      alert('Please enter search value');
    }
  }

  getmenu() {
    if (!!this.route.snapshot.paramMap.get('venueId')) {
      this.venueId = this.route.snapshot.paramMap.get('venueId');
    } else {
      if (localStorage.getItem('venue_id')) {
        this.venueId = localStorage.getItem('venue_id');
      } else {
        this.venueId = 1;
      }
    }

  }

  getCurrentUrl() {
    this.currentUrl = this.router.url;
    this.showHideSearchBar(this.currentUrl);
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd ) {
    //     this.currentUrl = event.url;  // event.url has current url
    //     this.showHideSearchBar(this.currentUrl);
    //   }
    // });
  }

  showHideSearchBar(currentUrl) {
    if (currentUrl === '/map') {
      this.showHideSearchInputText = true;
      this.showHideSearchText = false;
    } else {
      this.showHideSearchInputText = false;
      this.showHideSearchText = true;
    }

    if (currentUrl === '/editprofile') {
      this.showHideSearchText = false;
    }
  }


  showHideNavigation() {
    var currentUrl = this.router.url;

    var regExpVenuelist = '/venuelist/' + '.*$';
    var regExpAddpeople = '/addpeople/' + '.*$';

    if (currentUrl === '/map' || currentUrl === '/home' || currentUrl.match(regExpVenuelist) || currentUrl.match(regExpAddpeople)) {
      this.navHideShow = true;
    } else {
      this.navHideShow = false;
    }
  }

  showMobileHideNavigation() {
    var currentUrl1 = this.router.url;
    var regExpVenuelist = '/venuelist/' + '.*$';
    var regExpAddpeople = '/addpeople/' + '.*$';

    if (currentUrl1.match(regExpVenuelist)) {
      this.hideCartMenuForMobile = true;
    } else {
      this.hideCartMenuForMobile = false;
    }

    if (currentUrl1 === '/map' || currentUrl1 === '/home' || currentUrl1.match(regExpVenuelist) || currentUrl1.match(regExpAddpeople)) {
      this.navHideShowMobile = true;
    } else {
      this.navHideShowMobile = true;
    }
  }

  getVenueName() {
    if (!!localStorage.getItem('restaurant_name')) {
      this.displayVenuesText = false;
      this.displayText = true;

      this.venueName = localStorage.getItem('restaurant_name');
      this.searchZipCode = localStorage.getItem('searchZipCode');
      this.searchZipCodeDisplay = CommonFunction.removeUnderScoreAddSpace(this.searchZipCode);
    }
  }

  updateNextMenuId(){ 
    //update next menu_type_id
    if(localStorage.getItem('vip_menu_id') !== null && (localStorage.getItem('allvip_menu_id') !== null && ((JSON.parse(localStorage.getItem('allvip_menu_id'))).length)>0)){

      var sendData = {
        'cart_id': localStorage.getItem('cart_id')
      }

      this.CartService.addNewCartForVip(sendData).subscribe((res)=>{

        if(res.status=='success'){
          
          const menuTypeIdToDelete = parseInt(localStorage.getItem('allvip_menu_id_index'));
          const filteredArray = (JSON.parse(localStorage.getItem('allvip_menu_id'))).filter(obj => obj.indexing !== menuTypeIdToDelete);

          localStorage.setItem('allvip_menu_id',JSON.stringify(filteredArray));
          localStorage.setItem('vip_menu_id',filteredArray[0].menu_type_id);
          localStorage.setItem('sub_package_id',filteredArray[0].id);
          localStorage.setItem('allvip_menu_id_index',filteredArray[0].indexing);
          localStorage.setItem('vipnextcart_id',res.cartid);
          location.reload();

        }else{
          alert(res.message);
        }

      });
    }

  }
  get chkVipOption(){ if(localStorage.getItem('allvip_menu_id')!== null){ return JSON.parse(localStorage.getItem('allvip_menu_id')); }else{ return [] } }

  goToCheckout() {
    if(this.is_guest){
      if((this.cart_products_length > 0 && this.cart_products_length < 2) && localStorage.getItem('number_of_people') == '2'){
        var menuUrl = this.router.url;
        var regExpmenu ='/menu/'+'.*$';
        if(menuUrl.match(regExpmenu) ){
          setTimeout(()=>{
            if(this.showExtraGuestPopup){
              this.cartPanel.setCheckOutEvent(true);
              this.showExtraGuestPopup = false;
            }
          }, 300);
        }
      }else{
        this.router.navigate(['/checkout']);
      }
    }else{
      this.router.navigate(['/checkout']);
    }

    //update all vip menu id if tickettype is vip
    if(localStorage.getItem('ticket_type')!==null && localStorage.getItem('ticket_type')==='vip'){

      localStorage.setItem('allvip_menu_id',JSON.stringify([])); 

    }

  }

  editCart(cart, index, type) {
    $('#deleteItemFromCart i').addClass('fa fa-spinner fa-spin');
    var index = index;
    var qty_id = '#qty' + cart.id;
    var Qty_value = $(qty_id).val();
    if (type === 'sub') {
      Qty_value = parseInt(Qty_value) - 1;
    }
    if (type === 'add') {
      Qty_value = parseInt(Qty_value) + 1;
    }

    var cart_id = cart.id;

    var cart_data = {
      menuitem_id: cart.menuitem_id,
      customer_id: cart.customer_id,
      venu_id: cart.venu_id,
      total_person: cart.total_person,
      quantity: Qty_value,
      time: cart.time,
    }

    this.CartService.editInUsercart(cart_data, cart_id).subscribe(resultArray => {
      $('#deleteItemFromCart i').removeClass('fa fa-spinner fa-spin');
      var result = resultArray;
      if (result.status === 'success') {
        this.getUserCartData();
      } else {

      }
    })

  }

  logout() {
    CommonFunction.logOut();

    setTimeout(() => {
      // this.router.navigate(['signin']);
      var origin = window.location.origin;
        window.location.replace(origin);
    }, 500)
  }

  backBtn() {
    setTimeout(() => {
      // this.router.navigate(['signin']);
      var origin = window.location.origin;
        window.location.replace(origin);
    }, 500)
  }

  redirectBackMenu(){
    this.router.navigate(['vip-seating']);

    if(localStorage.getItem('unique_id')!==null){

      setTimeout(() => {
        $('#vip_menu_confirm_modal').modal('toggle');
      }, 2000);

    }

  }

  goToBack() {
    this.location.back();
  }

  removeItemFromCart(cart_Id, shisha_Id, is_pacakge = false) {

    $('#deleteItemFromCart i').addClass('fa fa-spinner fa-spin');
    var newdata = { 'option_id': cart_Id, 'shisha_id': shisha_Id }
    if(is_pacakge){
      newdata['is_pacakge'] = 1;
    }
    this.CartService.deleteInUserCart(newdata).subscribe(resultArray => {
      var result = resultArray;
      $('#deleteItemFromCart i').removeClass('fa fa-spinner fa-spin');
      setTimeout(() => {
        $('#content').click(); // for menu page get usercartdata
        this.getUserCartData();
        this.cartPanel.setDeleteCartSubject(true);
      }, 100);

      if(result.status === 'success'){
        // this.getUserCartData();
 
        if(localStorage.getItem('ticket_type')==='vip'){

          let indexing = Number.MIN_SAFE_INTEGER;
 
          var allMenuIdArray = JSON.parse(localStorage.getItem('allvip_menu_id')); 
          if(localStorage.getItem('cart_id')!==null && localStorage.getItem('cart_id')!=shisha_Id){
            
            if(allMenuIdArray.length>0){

              allMenuIdArray.forEach(item => {
                if (item.indexing > indexing) {
                  indexing = item.indexing;
                }
              });

            }else{
              indexing=0;
            }
 

            for(var i=0; i<result.cartOptionsData.quantity;i++){
              indexing++;
              allMenuIdArray.push({
                id: result.cartOptionsData.sub_package_id,
                menu_type_id: result.cartOptionsData.set_menu_type_id,
                indexing:indexing
              });
  
            }
  
            localStorage.setItem('allvip_menu_id',JSON.stringify(allMenuIdArray));

          }
          
        }

      }
    })
  }

  hideCartValidationPopUp() {
    $('#checkoutValidationPopup').hide();
    $('#close-cart').click();
    $('#add_to_cart_button_menu').click();
    if ( !$('#productModal').hasClass('show') ) {
      $('#productModal').modal('show');
    }
    // setTimeout(() => {
    //   this.cart_list.forEach(element_new => {
    //     var diplay = false;
    //     element_new.cart_options_menu.forEach(element => {
    //       var priceId = '#price' + element.id;
    //       if (element.price == Math.max.apply(null, element_new.priceArray) && diplay == false) {
    //         $(priceId).show();
    //         diplay = true;
    //       } else {
    //         $(priceId).hide();
    //       }
    //     });
    //   })
    // }, 10);
  }

  getUserCartData() {
    let that = this;
    this.is_login = CommonFunction.checkLogin();

    if (localStorage.getItem('unique_id')) {
      var time = localStorage.getItem('unique_id');
    }

    if (this.is_login) {
      this.login_user_id = localStorage.getItem('user_id');
    }

    if(localStorage.getItem('group_booking')){
      var group_booking = localStorage.getItem('group_booking');
    }else{
      var group_booking = '0';
    }

    if (!!this.login_user_id) {
      var data = { 'unique_id': time, 'id': this.login_user_id , 'venue_id':localStorage.getItem('venue_id'), 'group_booking': group_booking}
      if(localStorage.getItem('booking_available') == '1' || localStorage.getItem('group_booking')){
        data['is_reservation'] = 1;
      }else{
       data['is_reservation'] = 0;
      }
      if(this.is_party){
        data['is_party'] = 1;
      }
      if(localStorage.getItem('private_dinning') && localStorage.getItem('private_dinning') == '1') {
        data['is_private_dinning'] = 1;
      }
      this.CartService.getUserCartData(data).subscribe(resultArray => {
        var result = resultArray;
        if (result.status === 'success') {
          this.cart_data = true;
          this.cart_list = result.carts;
          this.cart_products_length = this.cart_list.length;
          this.cartPanel.setTotalCartSubject(this.cart_products_length);
          this.order_total = 0;
          this.discount_off = 0;
          this.grand_total = 0;
          this.deliveryCharge = 0.00;
          this.priceArray = [];
          if(localStorage.getItem('group_booking') && localStorage.getItem('group_booking') == '1'){
            if(that.cart_list.length != 0){
              if((that.cart_list[0].cart_options_menu.length != 0) || (that.cart_list[0].cart_options_extra.length != 0)){
                // localStorage.setItem('cart_id', that.cart_list[0].id);
                // $("#addUpdateCartButtonPopup").text('Update to Cart');
              }else{
                // localStorage.setItem('cart_id', that.cart_list[0].id);
              }
          }else{
            // $("#addUpdateCartButtonPopup").text('Add to Cart');
          }
          // if(this.cart_products_length != 0 )
          // if((that.cart_list[0].cart_options_menu.length == 0) && (that.cart_list[0].cart_options_extra.length == 0)){
          //   that.hideShowCartSection();
          // }
        }else{
          if(that.cart_list.length != 0){
            if(localStorage.getItem('group_booking') && localStorage.getItem('group_booking') == '1' || localStorage.getItem('is_takeaway') && localStorage.getItem('is_takeaway') == '1'){
              // localStorage.setItem('cart_id', that.cart_list[0].id);
              localStorage.setItem('unique_id', that.cart_list[0].unique_id);
            }
          }
        }
          this.cart_list.forEach(element_new => {
            element_new.priceArray = [];
            element_new.cart_options_menu.forEach(element => {
              if(element.set_menu_type_id !== null){
                let priceMultiply = (<any>parseFloat(element.price).toFixed(2) * <any>parseFloat(element.quantity));
                element_new.priceArray.push(priceMultiply);
                element.price = priceMultiply.toFixed(2);
              }else{
                if(element.item_option !== null){
                  let priceMultiply = (<any>parseFloat(element.item_option.price).toFixed(2) * <any>parseFloat(element.quantity));
                  element_new.priceArray.push(priceMultiply);
                  element.price = priceMultiply.toFixed(2);
                } else if (element.menu_items !== null) {
                  let priceMultiply = (<any>parseFloat(element.menu_items.price).toFixed(2) * <any>parseFloat(element.quantity));
                  element_new.priceArray.push(priceMultiply);
                  element.price = priceMultiply.toFixed(2);
                } else {
                  element_new.priceArray.push(0);
                }
              }
            });
            var maxPriceOrder_total = element_new.priceArray.reduce(function (acc, cur) { return parseFloat(acc) + parseFloat(cur); }, 0);


            if (maxPriceOrder_total > 0) {
              this.order_total = (parseFloat(maxPriceOrder_total) * parseInt(element_new.quantity)) + parseFloat(this.order_total);
              this.order_total = parseFloat(this.order_total).toFixed(2);
            } else {
              // this.order_total = 0;
            }

            this.discount_off = parseFloat(this.discount_off).toFixed(2);
            element_new.cart_options_extra.forEach(element => {
              this.order_total = (parseFloat(element.extra.price) * parseInt(element.quantity)) + parseFloat(this.order_total);
              this.order_total = parseFloat(this.order_total.toFixed(2));
              //this.discount_off = (parseFloat(element.price)*20 * parseInt(element.quantity))/100 + parseFloat(this.discount_off); // 20% off as per html
              this.discount_off = parseFloat(this.discount_off).toFixed(2);
            });
          });
          if(this.cart_list.length != 0 && this.cart_list[0].set_menu_type_id !== null){
            this.menu_type = this.cart_list[0].menu_type.type;
          }

          if(this.is_guest){
            this.order_total = 0;
            this.cart_list.forEach((element)=>{
              this.order_total = this.order_total + parseFloat(element.price);
            });
            this.grand_total = parseFloat(this.order_total) + parseFloat(this.deliveryCharge);
            this.grand_total = parseFloat(this.grand_total.toFixed(2));
          }else{
            if(this.menu_type == 'itemized'){
              this.order_total = parseFloat(this.cart_list[0].price);
              this.grand_total = parseFloat(this.cart_list[0].price) + parseFloat(this.deliveryCharge);
            }else{
              this.grand_total = parseFloat(this.order_total) + parseFloat(this.deliveryCharge);
              this.grand_total = parseFloat(this.grand_total.toFixed(2));
            }
          }
          // this.max_price_apply =  Math.max.apply(null,this.priceArray);
          if (localStorage.getItem('number_of_people')) {
            const people = localStorage.getItem('number_of_people');
            this.minShisha = Math.floor(parseInt(people) / 2);
            if (this.minShisha == 0) {
              this.minShisha = this.minShisha + 1;
            }
          }


          if(localStorage.getItem('group_booking') && localStorage.getItem('group_booking') == '1'){
            if(this.grand_total == 0){
              this.cart_data = false;
            }
          }

          this.grand_total = parseFloat(this.grand_total);

          let order_type = (localStorage.getItem('is_takeaway_order_type')) ? localStorage.getItem('is_takeaway_order_type') : "";
          if(order_type == "delivery" && !this.is_guest) {
            this.delivery_cost = (localStorage.getItem('is_takeaway_order_type')) ? localStorage.getItem('delivery_cost') : "";
            this.delivery_cost = parseFloat(this.delivery_cost).toFixed(2);
            this.delivery_cost = parseFloat(this.delivery_cost);

            this.grand_total = parseFloat(this.grand_total) + parseFloat(this.delivery_cost);
          }

          if(localStorage.getItem('group_booking') != '1'){
            if (this.cart_products_length >= this.minShisha) {
              $('#shishaMessageDisplayNew').css('display', 'none');
              $('#checkout_button_validation a').removeClass('disabled');
              this.shishaMessageDispaly = '';
              // this.hideCartValidationPopUp();
              $('#checkoutValidationPopup').hide();
            } else {
                         this.leftShisha = this.minShisha - this.cart_products_length;
                         var menuUrl = this.router.url;
                         var regExpmenu ='/menu/'+'.*$';
                         if(menuUrl.match(regExpmenu) ){
                           if(localStorage.getItem('group_booking') && localStorage.getItem('group_booking') == '1'){
                              $('#checkoutValidationPopup').hide();
                           }else{
                              $('#checkoutValidationPopup').show();
                           }
                         }else{
                           $('#checkoutValidationPopup').hide();
                         }
                         this.shishaMessageDispaly = 'You must place min of <span>'+ this.minShisha + '</span> orders';
                         $('#shishaMessageDisplayNew').css('display','block');
                         //$('#checkout_button_validation a').addClass('disabled')
                         //$('#checkout_button_validation a').addClass('disabled')
                          if(localStorage.getItem('group_booking') == '1') {
                            $('#checkout_button_validation a').addClass('disabled')
                            console.log("five : ");
                          }
            }
          }else{
            // this.showCartSection();
            if (this.cart_products_length >= 1) {
              $('#checkout_button_validation a').removeClass('disabled');
            }
          }
          // setTimeout(() => {
          //  this.cart_list.forEach(element_new => {
          //    var diplay = false;
          //    element_new.cart_options_menu.forEach(element => {
          //      var priceId = '#price' + element.id;
          //      if (element.price == Math.max.apply(null, element_new.priceArray) && diplay == false) {
          //        $(priceId).show();
          //        diplay = true;
          //      } else {
          //        $(priceId).hide();
          //      }
          //    });
          //  })
          //}, 10);


        } else {
          this.grand_total = 0.00;
          this.order_total = 0.00;
          this.cart_list = [];
          this.cart_products_length = this.cart_list.length;
          this.cart_data = false;
        }
      })
    } else {
      this.grand_total = 0.00;
      this.order_total = 0.00;
      this.cart_list = [];
      this.cart_products_length = this.cart_list.length;
      this.cart_data = false;

    }

  }

  getVenueByZipcode() {

    this.displayVenuesText = true;
    this.displayText = false;

    if (!!localStorage.getItem('searchZipCode')) {
      this.searchZipCode = localStorage.getItem('searchZipCode');
      this.searchZipCodeDisplay = CommonFunction.removeUnderScoreAddSpace(this.searchZipCode);
      var dataText = this.searchZipCodeDisplay;
      this.searchVenueName = '';
    }

    if (!!localStorage.getItem('search_venue_name')) {
      this.searchZipCodeDisplay = '';
      this.searchZipCode = localStorage.getItem('search_venue_name');
      this.searchVenueName = localStorage.getItem('search_venue_name');
      var dataText = CommonFunction.removeUnderScoreAddSpace(this.searchVenueName);
    }

    this.VenuelistService.getVenueByZipcode(dataText).subscribe(resultArray => {
      var result = resultArray;
      if (result.status === 'success') {
        if (result.venue.length > 0) {
          this.venueList = result.venue;
          this.currentCity = this.venueList[0].area;
          this.totalVenue = this.venueList.length;
          // result.venue.forEach(element => {
          //   var placeID = 'ChIJN1t_tDeuEmsRUsoyG83frY4'; // this is google rating
          //  // element.rating = this.getRatingFromPlaceId(placeID);
          // });
          // this.success = true;
          if (this.venueList.length <= 1) {
            $('.venuelist').addClass('ht-100vh');
          } else {
            $('.venuelist').addClass('ht-auto');
          }

        } else {
          //this.message = 'Venue not found';
          //this.failed = true;
          // setTimeout(() => {
          //   this.goToHome();
          // }, 2000);
        }
      } else {
        this.totalVenue = 0;
        this.currentCity = '';
        //this.message = result.message;
        //this.failed = true;
        // setTimeout(() => {
        //   this.goToHome();
        // }, 2000);
      }
    })
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  editItemFromCart(cart_Id) {
    $('.custom-control-input').prop('checked', false);
    $('#updateItemFormReSetButtonPopup').click(); // reset form
    this.cartPanel.editCart = true;
    localStorage.setItem('editCart_id', cart_Id);
    localStorage.setItem('cart_id', cart_Id);
    this.CartService.editCustomerCartData(cart_Id).subscribe(resultArray => {
      var result = resultArray;
      if (result.status === 'success') {

           this.editMenuCartArray(result.data);
      //   editData.menu.forEach(element => {
      //     if (!!element) {
      //       $('#item' + element).click(); // set menu data when edit call
      //       $('#item' + element).prop('checked', true);
      //     }
      //   })
      //   editData.extra.forEach(element => {
      //     if (!!element) {
      //       $('#item_extra' + element).click(); // set extra data when edit call
      //       $('#item_extra' + element).prop('checked', true);
      //     }
      //   })
      //   $("#extra_notes").val(result.data.extra_notes);
      } else {

      }
    })
  }

  checkHeaderParts(current_url) {
    this.headerRight = true;
    var regExpMenu = '/menu/' + this.venueId;
    this.headerLeft = true;
    this.hideCartSection()
    if (current_url.match("/forgotpassword") ||
        current_url.match("/donotmind/reservation") ||
        current_url.match("/donotmind") ||
        current_url.match("/select-table") ||
        current_url.match("/addreservation") ||
        current_url.match("/guest-list") ||
        current_url.match("/group-booking")||
        current_url.match("/checkout") ||
        current_url.match("/vip-seating")
       ) {
        this.headerRight = true;
        this.headerLeft = true;
        this.showCart = false;
    }
    if(
     // current_url.match("/checkout") ||
      current_url.match("/timeslot")||
     current_url.match(regExpMenu)){
      this.headerRight = true;
      this.headerLeft = true;
      this.showCart = true;
      $("#panel-cart").removeClass('show');
    }
    if (current_url.match("/confirmation") ||
        current_url.match("/payment") ||
        current_url.match("/thankyou") ||
        current_url.match("/group-booking-thankyou")||
        current_url.match("/reservation-payment") ||
        current_url.match("/editprofile") ||
        current_url.match("/guest-thankyou")) {
        this.headerRight = false;
        this.headerLeft = false;
        this.showCart =  false;
    }
  }

  getVenueByVenuId(venueId) {

    this.VenuelistService.getVenueByVenuId(venueId).subscribe(resultArray => {
      var result = resultArray;
      if (result.status === 'success') {
        if (result.venue.length > 0) {
          this.venueDetail = result.venue[0];
        } else {
          this.venueDetail = null;
        }
      } else {
      }
    })
  }

  showCartSection(){
    this.cartPanel.showCartPanel();
  }

  hideCartSection(){
   this.cartPanel.hideCartPanel();
  }

  editMenuCartArray(cart_data){
    let items = [];
    let extra = [];
    let price = 0;
    let data = {};
    cart_data.forEach((element, index)=>{
      if(element.menu_items != null){
        element.menu_items.category_type = element.menu_items.menucategory.category_type;
        element.menu_items.quantity = element.quantity;
        element.status = 1;
        element.menu_items.option_id = element.itemoption_id;
        element.menu_items.price = element.price;
        delete element.menu_items.menucategory;
        delete element.menu_items.menucategory_name;
        price = price + element.price;
        items.push(element.menu_items);
      }else{
        element.set_menu.quantity = 1;
        element.set_menu.set_menu_id = element.set_menu.id;
        items.push(element.set_menu);
      }
    });
    data['cart_data'] = {
      'items': items,
      'extra': extra,
    };
    data['price'] = cart_data[0].set_menu_type != null && cart_data[0].set_menu_type == 'package' ? cart_data[0].set_menu.price : cart_data[0].price;
    data['set_menu_type_id'] = cart_data[0].set_menu_type_id;
    data['set_menu_type'] = cart_data[0].set_menu_type;
    this.cartPanel.setCartSubject(data);
  }


  createNewOrderForVip(){
    $('#vip_menu_confirm_modal').modal('toggle');
    localStorage.removeItem('unique_id');
  }

  countinueVipExistOrder(){
    $('#vip_menu_confirm_modal').modal('toggle');
    this.router.navigate(['checkout']);
  }

}
